import { env } from '@/env';
import { useStatoTempoReale } from '@/lib/qsocials/statoTempoReale';
import { ricontrolloAmiciMs } from '@/lib/qsocials/tempoReale';
import { useGetDmUnreadQuery } from '@/services/dmApi';
import { useAppSelector } from '@/store/hooks';

/**
 * Il numero dei DM non letti, per il badge (D1). Fonte: `GET /social/dm/unread`, che dopo R6 conta solo le
 * conversazioni aperte — il client NON lo ricalcola dall'elenco (contratto §1-ter). Lo rileggono `dm.message`,
 * `dm.erased`, ogni sottoscrizione e il rientro (tempo reale), piu' la rete di sicurezza di R7.
 * ⚠️ Dove si mostra il badge dipende dall'ingresso (L-2238): questo hook non lo monta nessuno, ancora.
 */
export function useDmNonLetti(): number {
  const authed = useAppSelector((s) => s.auth.bridgeAuthenticated);
  const ricontrollo = ricontrolloAmiciMs(env.qsocialsWsUrl, useStatoTempoReale());
  const q = useGetDmUnreadQuery(undefined, {
    skip: !env.featureDmEnabled || !authed,
    pollingInterval: ricontrollo,
    skipPollingIfUnfocused: true,
    refetchOnFocus: true,
  });
  return q.data ?? 0;
}
